import React from "react";
import { Routes, Route } from "react-router-dom";
import AuthRoute from "./components/AuthRoute";
import Login from "./pages/Login";
import Homepage from "./pages/Homepage";
import RegistrationPage from "./pages/RegistrationPage";
import NotFound from "./components/NotFound";
import Layout from "./layout/Layout";
import MyBadge from "./pages/MyBadge";
import FloorPlan from "./pages/FloorPlan";
import AttendeeList from "./pages/AttendeeList";
import ExhibitorList from "./pages/ExhibitorList";
import SponsorList from "./pages/SponsorList";
import ProductList from "./pages/ProductList";
import Conference from "./pages/Conferences";
import Networking from "./pages/Networking";
import StrategyPage from "./pages/StrategyPage";
import MunicipalWaterProgram from "./pages/MunicipalWaterProgram";
import ProducedPage from "./pages/ProducedPage";
import Profile from "./pages/ProfilePage";
import SelectRole from "./pages/SelectRole";
import MyAgenda from "./pages/MyAgenda";
import ProductPage from "./pages/ProductPage";
import SpeakersList from "./pages/SpeakersList";
import FloorPlanSVG from "./pages/FloorPlanSvg";
import WaterTalksProgram from "./pages/WaterTalksProgram";
import HydrogenProgram from "./pages/HydrogenProgram";
import InnovationProgram from "./pages/InnovationProgram";
import ClosedRegistration from "./pages/ClosedRegistration";

function App() {
  return (
    <Routes>
      {/* Root path shows closed registration */}
      <Route path="/" element={<ClosedRegistration />} />

      {/* App accessible via /demo paths */}
      <Route path="/demo/login" element={<SelectRole />} />
      <Route path="/demo/login/:eventId/:role" element={<Login />} />
      <Route
        path="/demo/register/:eventId/:role"
        element={<RegistrationPage />}
      />

      <Route path="/demo" element={<Layout />}>
        <Route
          index
          element={
            <AuthRoute>
              <Homepage />
            </AuthRoute>
          }
        />
        <Route
          path="my-badge"
          element={
            <AuthRoute>
              <MyBadge />
            </AuthRoute>
          }
        />
        <Route
          path="floor-plan"
          element={
            <AuthRoute>
              <FloorPlanSVG />
            </AuthRoute>
          }
        />
        <Route
          path="attendees"
          element={
            <AuthRoute>
              <AttendeeList />
            </AuthRoute>
          }
        />
        <Route
          path="exhibitors"
          element={
            <AuthRoute>
              <ExhibitorList />
            </AuthRoute>
          }
        />
        <Route
          path="sponsors"
          element={
            <AuthRoute>
              <SponsorList />
            </AuthRoute>
          }
        />
        <Route
          path="products"
          element={
            <AuthRoute>
              <ProductPage />
            </AuthRoute>
          }
        />
        <Route
          path="conferences"
          element={
            <AuthRoute>
              <Conference />
            </AuthRoute>
          }
        />
        <Route
          path="networking"
          element={
            <AuthRoute>
              <Networking />
            </AuthRoute>
          }
        />
        <Route
          path="strategic"
          element={
            <AuthRoute>
              <StrategyPage />
            </AuthRoute>
          }
        />
        <Route
          path="municipal"
          element={
            <AuthRoute>
              <MunicipalWaterProgram />
            </AuthRoute>
          }
        />
        <Route
          path="produced"
          element={
            <AuthRoute>
              <ProducedPage />
            </AuthRoute>
          }
        />
        <Route
          path="innovation"
          element={
            <AuthRoute>
              <InnovationProgram />
            </AuthRoute>
          }
        />
        <Route
          path="hydrogen"
          element={
            <AuthRoute>
              <HydrogenProgram />
            </AuthRoute>
          }
        />
        <Route
          path="water-talks"
          element={
            <AuthRoute>
              <WaterTalksProgram />
            </AuthRoute>
          }
        />
        <Route
          path="profile"
          element={
            <AuthRoute>
              <Profile />
            </AuthRoute>
          }
        />
        <Route
          path="my-agenda"
          element={
            <AuthRoute>
              <MyAgenda />
            </AuthRoute>
          }
        />
        <Route
          path="speakers"
          element={
            <AuthRoute>
              <SpeakersList />
            </AuthRoute>
          }
        />

        {/* Catch-all for any non-matching route under /demo */}
        <Route path="*" element={<NotFound />} />
      </Route>

      {/* Catch-all for any other path - redirect to closed registration */}
      <Route path="*" element={<ClosedRegistration />} />
    </Routes>
  );
}

export default App;
